// extracted by mini-css-extract-plugin
export default {"warningText":"CreateProposalButton_warningText__+Uqt5","spinner":"CreateProposalButton_spinner__n2ZAm"};